// src/Components/HeaderAdmin.js
import React from 'react';
// import { Link } from 'react-router-dom';
import "./Header.css";
import { Container, Navbar, Nav } from "react-bootstrap";

const Header = () => {
    return (
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container>
            <Navbar.Brand href="#">WebDoc</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
              <Nav.Link href="DoctorRequest">DoctorRequest</Nav.Link>
              {/* <Nav.Link href="DoctorRequest">DoctorList</Nav.Link> */}

                <Nav.Link href="#">LogOut</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
    );
};

export default Header;


